import { useEffect, useRef, useState } from "react"
import { usePageNumberContext } from "./page-number-context"

export default function PageNumber() {
  const { register, getTotalPages } = usePageNumberContext()
  const [pageNumber, setPageNumber] = useState<number | null>(null)
  const didRegister = useRef(false)

  useEffect(() => {
    if (!didRegister.current) {
      const page = register()
      setPageNumber(page)
      didRegister.current = true
    }
  }, [register])

  if (pageNumber === null) return null

  const totalPages = getTotalPages()

  return (
<div
  className="w-100 d-flex align-items-end justify-content-center"
  style={{
      position: 'absolute',
      fontSize: '12px',
      color: '#888',
      height:'288mm',
      // width: '210mm'
  }}
>
  Page {pageNumber} of {totalPages}
</div>
  )
}

